let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gw4Pw")).then(() => parcelRequire('9yLSY'));